import React, { useEffect } from "react";

let openOverlayCount = 0;
const SCROLL_LOCK_CLASS = "dp-overlay-open";

/**
 * Blocking overlay shown when the protected view must be hidden:
 *  - full screen required / return to full screen
 *  - window blurred, tab hidden, DevTools open
 *  - access revoked (focus loss limit / capture detected)
 *
 * Renders nothing when not blurred. Text is fully overridable so it can pull
 * from the existing DocumentRPD translations map.
 */
export function ProtectionOverlay({
  visible,
  title,
  message,
  actionLabel,
  onAction,
}) {
  useEffect(() => {
    if (!visible) return undefined;
    openOverlayCount += 1;
    document.documentElement.classList.add(SCROLL_LOCK_CLASS);
    document.body.classList.add(SCROLL_LOCK_CLASS);
    return () => {
      openOverlayCount = Math.max(openOverlayCount - 1, 0);
      if (openOverlayCount === 0) {
        document.documentElement.classList.remove(SCROLL_LOCK_CLASS);
        document.body.classList.remove(SCROLL_LOCK_CLASS);
      }
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="dp-overlay" onContextMenu={(e) => e.preventDefault()}>
      <div className="dp-overlay-card">
        {title ? <h4 className="dp-overlay-title">{title}</h4> : null}
        {message ? <p className="dp-overlay-message">{message}</p> : null}
        {actionLabel && typeof onAction === "function" ? (
          <button type="button" className="dp-overlay-btn" onClick={onAction}>
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}

export default ProtectionOverlay;
